module.exports = __webpack_public_path__ + "static/img/home2.09110bf0.png";